import React from 'react';

import MerchantContext from './MerchantContext';
import useMerchantProvider from './useMerchantProvider';

const MerchantProvider: React.FC<{}> = ({ children }) => {
	const { merchantName } = useMerchantProvider();

	return <MerchantContext.Provider value={{ merchantName }}>{children}</MerchantContext.Provider>;
};

export default MerchantProvider;
